/**
 * @generated SignedSource<<ef67110adbf83fdeb62154674dbe8774>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CommunicationPage_study$data = {
  readonly id: string;
  readonly tenant: {
    readonly " $fragmentSpreads": FragmentRefs<"SelectTemplateModal_tenant">;
  };
  readonly " $fragmentType": "CommunicationPage_study";
};
export type CommunicationPage_study$key = {
  readonly " $data"?: CommunicationPage_study$data;
  readonly " $fragmentSpreads": FragmentRefs<"CommunicationPage_study">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CommunicationPage_study",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TenantNode",
      "kind": "LinkedField",
      "name": "tenant",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SelectTemplateModal_tenant"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "StudyNode",
  "abstractKey": null
};

(node as any).hash = "92372e2491b2d4f71d6cc34eb32bfce2";

export default node;
